import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ expeditedUserPhoneError: string }>;

export const DispatchExpeditedUserPhoneError: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/ExpeditedUserPhoneError",
        expeditedUserPhoneError: props.parameter.expeditedUserPhoneError,
    });
};

export const chain = [DispatchExpeditedUserPhoneError];

const setExpeditedUserPhoneError = createHandlerChainRunner(chain, "setExpeditedUserPhoneError");
export default setExpeditedUserPhoneError;
